<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('GovernmentRegulation.companyNum')">
                    <el-input
                      size="mini"
                      v-model="formInline.companyNum"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('ContractManagement.contractId')">
                    <el-input
                      size="mini"
                      v-model="formInline.name"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{$t('common.btn.search')}}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del"
                      >{{$t('common.btn.cancel')}}</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                v-if="isPrimaryKey('JURISDICTIONALCOMPANIES_DELETE')"
                  type="text"
                  @click="deleteJurisdictional"
                  :disabled="this.selected.length != 1"
                  >{{$t('common.btn.delete')}}</el-button
                >
                <el-button v-if="isPrimaryKey('JURISDICTIONALCOMPANIES_ADD')" type="text" @click="addJurisdictional">{{$t('common.btn.add')}}</el-button
                >
                <el-button v-if="isPrimaryKey('JURISDICTIONALCOMPANIES_IMPORT')" type="text" @click="BulkImport">{{$t('common.btn.batchUpload')}}</el-button
                >
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="650px"
        :before-close="closeDia"
        class="addDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="companyNum"
            :label="$t('GovernmentRegulation.companyNum')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.companyNum"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="name"
            :label="$t('common.companyName')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.name"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{$t('common.btn.cancel')}}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')"
            >{{$t('common.btn.confirm')}}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        width="620px"
        :before-close="closeBatchDia"
        :title="$t('common.btn.batchUpload')"
        :visible.sync="dialogBatchFormVisible"
        class="batchDialong"
        :close-on-click-modal="false"
      >
        <div class="right-file">
          <el-button type="text" size="mini" @click="TemplateFile()"
            >{{$t('common.btn.downloadModelFile')}}</el-button
                >
        </div>
        <div class="upload-file">
          <img src="../../../assets/images/upload.png" />
          <div>{{$t('common.btn.clickUploadFile')}}</div>
          <input @change="uploadCar()" id="uploadDom" type="file" />
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogBatchFormVisible = false" class="btn-del"
            >{{$t('common.btn.cancel')}}</el-button
                >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import JurisdictionalCompanies from "./JurisdictionalCompanies";
export default JurisdictionalCompanies;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
